/**
 * localize(obj, field, locale) — Dinamik veri (Dog, Event vb.) için TR/EN alan seçici.
 *
 * Kullanım: locale-aware bir field değeri döner.
 *   locale === "en" ise: obj[`${field}_en`] varsa onu, yoksa translations.js
 *                        dict'inde TR değerine karşılık gelen EN varsa onu,
 *                        aksi halde TR değeri (obj[field]).
 *   locale === "tr" ise: obj[field]
 */
import { HARDCODED_EN } from "@/lib/translations";
import { useLanguage } from "@/context/LanguageContext";

export function localize(obj, field, locale) {
  if (!obj) return "";
  const tr = obj[field] || "";
  if (locale === "en") {
    const en = obj[`${field}_en`];
    if (en && String(en).trim()) return en;
    // Fallback: known TR strings in translations.js dict.
    if (tr) {
      if (HARDCODED_EN[tr]) return HARDCODED_EN[tr];
      // Try whitespace-normalized lookup (handles \n / double spaces).
      const norm = String(tr).replace(/\s+/g, " ").trim();
      if (norm !== tr && HARDCODED_EN[norm]) return HARDCODED_EN[norm];
    }
  }
  return tr;
}

/**
 * useLocalize — React hook that returns a bound `L(obj, field)` shortcut
 * for the current locale.
 */
export function useLocalize() {
  const { locale } = useLanguage();
  return (obj, field) => localize(obj, field, locale);
}
